<template>
  <div class="feature-tile" :class='$layout.isMobile ? "mobile" : undefined'>
    <div class="cont" :class="$layout.less1366 ? 'flex-column' : 'flex-row'">
      <div class="flex-row justify-content-center">
        <Icon class="icon" :type="icon"/>
      </div>
      <div class="flex-column cont" :class="$layout.less1366 ? 'center' : undefined">
        <h4>{{title}}</h4>
        <p>{{text}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from "@/components/Icon";

export default {
  name: 'FeatureTile',
  components: {
    Icon
  },
  props: {
    icon: String,
    title: String,
    text: String,
  },
}
</script>

<style lang="scss" scoped>

.feature-tile.mobile {
  .cont {
    .icon {
      width: 34px;
      height: 34px;      
    }
  }
}

.flex-row {
  .feature-tile {
    flex: 1 0 250px;
  }
}

.feature-tile {
  padding: 15px;
  border-radius: $tile-border-radius;
  background: $bg-color-1;
  fill: $color-1;
  color: $color-1-active;
  gap: 10px;

  .cont {
    gap: 15px;

    .icon {
      width: 57px;
      height: 54px;
    }
  }

  .cont.center {
    text-align: center;
  }

}

</style>
